// The commitment write path's function references (bead hf-e6-commitments-coverage-udt.2).
//
// Through `convex/_generated/api` and nothing else. The two mutations here are the
// product's most consequential: `volunteer` runs the atomic claim guard, and
// `withdraw` is the only way out of an agreement. Both are boundary-wrapped, so the
// caller's Membership and capability were resolved before either handler ran.

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

export const commitmentQueries = {
  listMine: api.domain.commitments.listMyCommitments,
  /** The caller's outstanding rechecks, each with what changed (bead ...udt.5). */
  myRechecks: api.domain.commitments.myRechecks,
  /** Who has and has not answered, for the organiser who made the change. */
  recheckAudience: api.domain.commitments.recheckAudience,
} as const;

export const commitmentMutations = {
  volunteer: api.domain.commitments.volunteer,
  recordProxy: api.domain.commitments.recordProxy,
  withdraw: api.domain.commitments.withdraw,
  /**
   * The renewed Yes/No after a material change (COM-015, plan §10.9).
   *
   * One mutation for both answers, because it is one decision with two outcomes —
   * and because "declined after a change" and "withdrew unprompted" must reach the
   * audit trail as different facts, which routing No to `withdraw` would prevent.
   */
  reconfirm: api.domain.commitments.reconfirm,
  /**
   * The same answer, recorded on somebody's behalf (bead hf-ww3).
   *
   * Its own mutation and its own capability: the offline member is asked again by the
   * cascade like everybody else and will never open the app to answer, so an
   * organiser records what they said — with a FRESH agreement source, because the
   * change is exactly what they had not seen when they first agreed.
   */
  reconfirmProxy: api.domain.commitments.reconfirmProxy,
} as const;

export type ListMyCommitmentsResult = FunctionReturnType<typeof commitmentQueries.listMine>;
export type MyRechecksResult = FunctionReturnType<typeof commitmentQueries.myRechecks>;
export type RecheckAudienceResult = FunctionReturnType<typeof commitmentQueries.recheckAudience>;
export type ReconfirmOutcome = FunctionReturnType<typeof commitmentMutations.reconfirm>;
export type VolunteerOutcome = FunctionReturnType<typeof commitmentMutations.volunteer>;
export type RecordProxyOutcome = FunctionReturnType<typeof commitmentMutations.recordProxy>;
export type WithdrawOutcome = FunctionReturnType<typeof commitmentMutations.withdraw>;
